import { IMenu } from '@dfl/mui-react-common';
import {
  AccountBalanceOutlined,
  PaletteOutlined,
  PaymentsOutlined,
  RadioButtonCheckedOutlined,
} from '@mui/icons-material';
import { AiAssistantIcon } from 'components/icons/menus/AiAssistantIcon';
import { AI_ASSISTANT_PERMISSIONS } from 'modules/cms/seo/ai-assistant/constants';
import { ShippingStandardIcon } from 'modules/sales/common/components/icons/ShippingStandardIcon';
import { BANK_PERMISSIONS } from 'modules/sales/settings/bank/constants';
import { SHIPPING_PERMISSIONS } from 'modules/sales/settings/home-delivery/constants';
import { PAYMENT_METHOD_PERMISSIONS } from 'modules/sales/settings/payment-settings/constants';
import { FRAUD_PERMISSIONS } from 'modules/cms/fraud-integration/constants/fraud.permissions';
import { TRACKER_PERMISSIONS } from 'modules/cms/tracker-integration/constants/tracker-assistant.permissions';
import { TIP_PERMISSIONS } from 'modules/settings/tip/constants';
import { disabledSettingsTips, disabledSettingsBanks, disabledSettingsAiFraud, disabledSettingsAiTracker } from 'utils/flags-utils';

export const SETTINGS_MENU: Array<IMenu & { modulePath?: string; items: any[] }> = [
  {
    title: 'main_menu.admin.section.settings.invoice',
    prefix: '/settings',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.settings.payment-settings',
        path: '/settings/payment-settings',
        partialMatch: true,
        icon: <PaymentsOutlined fontSize='small' />,
        permissions: [PAYMENT_METHOD_PERMISSIONS.PAYMENT_METHOD_VIEW],
      },
      {
        title: 'main_menu.admin.section.settings.billing-settings',
        path: '/settings/billing-settings',
        partialMatch: true,
        icon: <PaletteOutlined fontSize='small' />,
        permissions: [PAYMENT_METHOD_PERMISSIONS.PAYMENT_FACTURATION_CONFIG],
      },
      ...(!disabledSettingsBanks ? [{
        title: 'main_menu.admin.section.settings.banks',
        path: '/settings/banks',
        partialMatch: true,
        icon: <AccountBalanceOutlined fontSize='small' />,
        permissions: [BANK_PERMISSIONS.BANK_VIEW, PAYMENT_METHOD_PERMISSIONS.PAYMENT_METHOD_VIEW],
        atLeastOne: true,
        disabled: true,
      }] : []),
      ...(!disabledSettingsTips ? [{
        title: 'main_menu.admin.section.settings.tips',
        path: '/settings/tips',
        partialMatch: true,
        icon: <PaymentsOutlined fontSize='small' />,
        permissions: [TIP_PERMISSIONS.TIP_VIEW],
      }] : []),
    ],
  },
  {
    title: 'main_menu.admin.section.settings.shipping',
    prefix: '/settings',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.settings.shipping-settings',
        path: '/settings/shipping-settings',
        partialMatch: true,
        icon: <ShippingStandardIcon fontSize='small' />,
        permissions: [SHIPPING_PERMISSIONS.SHIPPING_VIEW],
      },
      {
        title: 'main_menu.admin.section.settings.delivery-points',
        path: '/settings/delivery-points',
        partialMatch: true,
        icon: <RadioButtonCheckedOutlined fontSize='small' />,
        permissions: [SHIPPING_PERMISSIONS.SHIPPING_VIEW],
        disabled: true,
      },
    ],
  },
  {
    title: 'main_menu.admin.section.settings.ai',
    prefix: '/settings',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.settings.ai-assistant',
        path: '/settings/ai-assistant',
        partialMatch: true,
        icon: <AiAssistantIcon fontSize='small' />,
        permissions: [AI_ASSISTANT_PERMISSIONS.AI_ASSISTANT_CONFIG],
      },
      ...(!disabledSettingsAiFraud ? [{
        title: 'main_menu.admin.section.settings.ai-fraud',
        path: '/settings/ai-fraud',
        partialMatch: true,
        icon: <AiAssistantIcon fontSize='small' />,
        permissions: [FRAUD_PERMISSIONS.INTEGRATION_DAILYFRAUD],
      }] : []),
      ...(!disabledSettingsAiTracker ? [{
        title: 'main_menu.admin.section.settings.ai-tracker',
        path: '/settings/ai-tracker',
        partialMatch: true,
        icon: <AiAssistantIcon fontSize='small' />,
        permissions: [TRACKER_PERMISSIONS.TRACKER_INTEGRATION_CONFIG],
      }] : []),
    ],
  },
];
